import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import edfService from '~/services/Edf';
import uniqueCache from '~/services/uniqueCache';

import { initEdf, reset } from './loadingFiles';

const initialState = {
    spo2: {
        isInProgress: false,
        channelIndex: null,
        min: null,
        max: null,
        avg: null,
    },
    hr: {
        isInProgress: false,
        channelIndex: null,
        min: null,
        max: null,
        avg: null,
    },
};
Object.freeze(initialState);

const aggregationSlice = createSlice({
    name: 'edfAggregations',
    initialState,
    reducers: {
        setSPO2Aggregations: (state, { payload }) => {
            state.spo2.min = payload.min;
            state.spo2.max = payload.max;
            state.spo2.avg = payload.avg;

            uniqueCache.set(
                {
                    minSpo2: payload.min,
                    maxSpo2: payload.max,
                    avgSpo2: payload.avg,
                },
                'aggregations'
            );
        },
        setHRAggregations: (state, { payload }) => {
            state.hr.min = payload.min;
            state.hr.max = payload.max;
            state.hr.avg = payload.avg;

            uniqueCache.set(
                {
                    minHr: payload.min,
                    maxHr: payload.max,
                    avgHr: payload.avg,
                },
                'aggregations'
            );
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(initEdf, (state, { payload: { headers } }) => {
                const hrIndex = headers.labels.findIndex((label) =>
                    /heart rate/.test(label.toLowerCase())
                );

                if (hrIndex >= 0) {
                    state.hr.channelIndex = hrIndex;
                }

                const spo2Index = headers.labels.findIndex((label) =>
                    /spo2/.test(label.toLowerCase())
                );

                if (spo2Index >= 0) {
                    state.spo2.channelIndex = spo2Index;
                }
            })
            .addCase(reset, () => initialState)
            .addCase(getSPO2Aggregations.pending, (state, { payload }) => {
                state.spo2.isInProgress = true;
            })
            .addCase(getSPO2Aggregations.fulfilled, (state, { payload }) => {
                state.spo2.isInProgress = false;
            })
            .addCase(getHRAggregations.pending, (state, { payload }) => {
                state.hr.isInProgresss = true;
            })
            .addCase(getHRAggregations.fulfilled, (state, { payload }) => {
                state.hr.isInProgresss = false;
            });
    },
});

export const getSPO2Aggregations = createAsyncThunk(
    'edf/aggregations/spo2',
    async ({ spo2Index, validRegions }, thunkAPI) => {
        return edfService
            .aggregateChannel(spo2Index, validRegions)
            .then((response) =>
                thunkAPI.dispatch(aggregationSlice.actions.setSPO2Aggregations(response))
            );
    }
);

export const getHRAggregations = createAsyncThunk(
    'edf/aggregations/hr',
    async ({ hrIndex, validRegions }, thunkAPI) => {
        return edfService
            .aggregateChannel(hrIndex, validRegions)
            .then((response) =>
                thunkAPI.dispatch(aggregationSlice.actions.setHRAggregations(response))
            );
    }
);

export default aggregationSlice.reducer;
